export default __webpack_public_path__ + "static/bg-notes-ccee28edb83d59caf0289d81277b6623.webp";